import { render, staticRenderFns } from "./friendList.vue?vue&type=template&id=0e716a15&scoped=true"
import script from "./friendList.vue?vue&type=script&lang=js"
export * from "./friendList.vue?vue&type=script&lang=js"
import style0 from "./friendList.vue?vue&type=style&index=0&id=0e716a15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e716a15",
  null
  
)

export default component.exports